import { Base } from './Base.js';
import { Chat } from './variants/Chat/index.js';
import { Menu } from './variants/Menu/index.js';
import { User } from './variants/User/index.js';
import { Vip } from './variants/Vip/index.js';
import { Wallet } from './variants/Wallet/index.js';

const BabyButton = {
  Base,
  Chat,
  Vip,
  User,
  Menu,
  Wallet
};

export { BabyButton };
//# sourceMappingURL=index.js.map
